import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";

interface LanguageSwitcherProps {
  variant?: "navbar" | "navbar-light" | "footer";
}

export function LanguageSwitcher({ variant = "navbar" }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "es" ? "en" : "es";
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className={cn(
        "flex items-center gap-1.5 text-sm font-semibold transition-all duration-300 rounded-full px-3 py-1.5",
        variant === "footer"
          ? "text-white/60 hover:text-white bg-white/5 hover:bg-white/10"
          : variant === "navbar-light"
            ? "text-foreground/60 hover:text-foreground border border-border hover:border-primary/30 hover:bg-primary/5"
            : "text-white/60 hover:text-white border border-white/10 hover:border-white/25 hover:bg-white/[0.06]"
      )}
      aria-label="Change language"
    >
      <Globe className="w-3.5 h-3.5" />
      <span className="uppercase text-xs tracking-wider">{i18n.language === "es" ? "EN" : "ES"}</span>
    </button>
  );
}
